<template>
    <v-data-table :must-sort=true :headers="getTableHeaders()" :items="bookings" 
                  :disable-pagination=true  flat :height="calculateRemainingHeight()"
                  dense fixed-header item-key="bookingnr" no-data-text="No data available" 
                  hide-default-footer class="score-trans ml-0 mt-2">  

        <template v-slot:item="booking">
            <tr :class="{'non-standard-booking': booking.item.hustcode !== 'B-STD'}">
                <td class="td-style">
                    <div>
                        <v-img contain v-if="booking.item.source==='airbnb'" src="@/assets/dashboard/logo/airbnb.svg" alt="" height=30 width=30 />
                        <v-img contain v-else-if="booking.item.source==='bookingcom'" src="@/assets/dashboard/logo/booking.svg" alt="" height=30 width=30 />
                        <v-img contain v-else-if="booking.item.source==='holidu'" src="@/assets/dashboard/logo/holidu.svg" alt="" height=30 width=30 />
                        <v-img contain v-else-if="booking.item.source==='vrbo'" src="@/assets/dashboard/logo/vrbo.svg" alt="" height=30 width=30 />
                        <v-img contain v-else-if="booking.item.source==='VFY'" src="@/assets/dashboard/logo/vfy.png" alt="" height=30 width=30 />
                        <v-img contain v-else-if="booking.item.source==='hometogo'" src="@/assets/dashboard/logo/hometogo.svg" alt="" height=30 width=30 />
                        <v-img contain v-else-if="booking.item.source==='chaletnl'" src="@/assets/dashboard/logo/chalet.svg" alt="" height=30 width=30 />
                        <v-img v-else src="@/assets/dashboard/logo/other.png" alt="" height=30 width=30 />
                    </div>
                    <div class="mt-1">
                        <b>{{ booking.item.bookingdate }}</b>
                    </div>
                </td>
                <td class="td-style" align="left">
                    <div  v-on:click="$router.open('/huis/onHuis/' + booking.item.huis_encrid)" class="link-color">{{ booking.item.accommodation }}</div>
                    <div v-if="current_size==='xs'" class="link-color" v-on:click="$router.open('/huov/onHuov/' + booking.item.huov_encrid)">{{ booking.item.bookingnr }}</div>
                </td>
                <td v-if="current_size!=='xs'" class="td-style" align="left">
                    <div class="link-color" v-on:click="$router.open('/huov/onHuov/' + booking.item.huov_encrid)">{{ booking.item.bookingnr }}</div>
                </td>
                <td  class="td-style">
                    <div>{{ booking.item.hustcode }}</div>
                </td>
                <td class="td-style">
                    <div> {{ booking.item.stay_from }} </div>
                    <div> {{ booking.item.stay_until }} </div>
                </td>
                <td v-if="current_size!=='xs'" class="td-style" align="right">{{ booking.item.value }}</td>
                <td v-else class="td-style val-width" align="right">{{ booking.item.value }}</td>
            </tr>
        </template>                                                                                                                                               
    </v-data-table> 
</template>

<script>

import mxscreensize from '@/components/js/screensize';

export default {    
    props: {
        bookings: Array,
        height_correction: Number,
    },    
    mixins:[mxscreensize],
    methods: {
        getTableHeaders(){
            return [
                { text: "Entry", value: "bookingdate", align: "left", sortable: false },
                { text: "Acco", value: "accommodation", sortable: false },
                { text: "Booking", sortable: false, value: "bookingnr" },
                { text: "Code", align: "left", sortable: false, value: "hustcode" },
                { text: "Stay", align: "start", sortable: false, value: "stay_from" },
                { text: "Value", align: "end", sortable: false, value: "value" },
            ];
        },             
        calculateRemainingHeight(){     
            if(this.wInnerHeight - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction) < 200) {
                return (this.wInnerWidth - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction));
            }            
            return (this.wInnerHeight - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction));            
        },
   }
}

</script>

<style scoped>
    .score-trans {
        background: transparent !important;
    }
    .small-font{
        font-size: 12px !important;
    }    
    .td-style{
        vertical-align: top;
        border-top: 5px solid transparent;    
        font-size: 12px !important;
    }
    .val-width{
        width: 100%;
    }
    .link-color{
        color: blue !important;
        cursor: pointer;
    }
    .non-standard-booking{
        background-color: rgba(255, 165, 0, 0.2) !important;
    }
    ::v-deep .non-standard-booking:hover{
        background-color: rgba(255, 165, 0, 0.3) !important;
    }
    ::v-deep tr:hover{
        background-color: rgba(255, 255, 255, 0.4) !important;
    }


</style>